<template>
  <div class="qualityIndicatorsReport">
    <!-- 导航栏 -->
    <nav-header :head-title="headeName"></nav-header>
    <div class="container">
      <!-- 已完成盒子 -->
      <div
        class="user-info"
        v-if="this.reportData.state === '1' || this.reportData.state === '2'"
      >
        <div class="row-status df-between">
          <div class="status">表单已提交上报</div>
          <div class="edit-btn df-center" @click="goEdit">
            {{ reportStatus == 0 ? "我要修改" : "已提交" }}
          </div>
        </div>
        <div class="row-update-info">
          最后修改人及时间：<span>{{ reportData.modUserName }}</span
          >{{ reportData.modTime }}
        </div>
      </div>
      <template v-if="this.reportDataList && this.reportDataList.length > 0">
        <!-- 卡片容器 -->
        <!-- -->
        <div class="card-container">
          <div
            class="card"
             :class="{ 'last-option': item.lastOptions && item.isShow}"
            v-for="(item, index) in reportDataList"
            :key="index"
          >
            <!-- 标题 -->
            <div
              class="title-box"
              v-if="item.isShow && item.optionInputType == 6"
            >
              <div class="main-title df-between">
                <span class="name">{{ item.optionName }}</span>
                <span class="rate">{{ item.expressionVal }}</span>
              </div>
              <div class="sub-title">
                {{ item.optionTip }}
              </div>
              <!-- 错误提示 -->
              <div class="error-tip d-flex" v-if="item.errorFlag">
                <img src="../../assets/images/i-error.png" alt="" />
                <span>{{ item.ruleExplain }}</span>
              </div>
            </div>
            <!-- 标题下的每一项 -->
            <div>
              <template v-if="item.isShow">
                <!-- 填空 -->
                <div
                  class="cell-item d-flex"
                  v-if="item.optionInputType == 2 || item.optionInputType == 8"
                >
                  <span class="asterisk" v-if="item.isRequire == 1">*</span>
                  <div class="title">{{ item.optionName }}</div>
                  <!-- value=value.replace(/[^\d]/g,'') > 200 ? 200 : value.replace(/[^\d]/g,'') -->
                  <van-field
                    v-model="item.optionValue"
                    :type="item.optionInputType == 2 ? 'number' : 'digit'"
                    class="va-input"
                    placeholder="请填写"
                    input-align="center"
                    max="10"
                    :class="{
                      'error-ipt': item.errorFlag || item.iptErrorFlag,
                    }"
                    @input="handleInput($event, item)"
                    :disabled="forbid"
                  />
                  <!-- <input
                  type="text"
                  placeholder="请填写"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="item2.optionValue"
                  :class="{ 'error-ipt': item2.errorFlag }"
                /> -->
                  <div class="unit">{{ item.unit }}</div>
                </div>
                <!-- 是否 -->
                <div class="cell-item d-flex" v-if="item.optionInputType == 3">
                  <span class="asterisk" v-if="item.isRequire == 1">*</span>
                  <van-radio-group
                    v-model="item.optionValue"
                    direction="horizontal"
                    icon-size="18px"
                    :disabled="forbid"
                    @change="toggleRadioChange(item, index)"
                  >
                    <van-radio name="1">是</van-radio>
                    <van-radio name="2">否</van-radio>
                  </van-radio-group>
                </div>
                <!-- 有无 -->
                <div
                  class="cell-item d-flex"
                  v-if="item.optionInputType == 1"
                  @click="toggleRadioChange(item, index)"
                >
                  <span class="asterisk" v-if="item.isRequire == 1">*</span>
                  <van-radio-group
                    v-model="item.optionValue"
                    direction="horizontal"
                    icon-size="18px"
                  >
                    <van-radio name="1">有</van-radio>
                    <van-radio name="2">无</van-radio>
                  </van-radio-group>
                </div>
                <!-- 错误提示 -->
                <div
                  class="error-tip d-flex"
                  v-if="item.optionInputType != 7 && item.errorFlag"
                >
                  <img src="../../assets/images/i-error.png" alt="" />
                  <span>{{ item.ruleExplain }}</span>
                </div>
              </template>
            </div>
            <!-- 卡片占位 -->
            <!-- <div class="card-hodler" v-if="item.isShow"></div> -->
          </div>
        </div>
        <!-- 占位盒子 -->
        <div class="holder-box"></div>
        <!-- 操作按钮 -->
        <div
          class="btn-group df-between"
          v-if="this.reportData.state === '0' && reportStatus == 0"
        >
          <div class="storage df-center" @click="saveIndexOptionList('0')">
            暂存
          </div>
          <div class="submit df-center" @click="saveIndexOptionList('1')">
            提交
          </div>
        </div>
        <div
          class="btn-group"
          v-if="this.reportData.state === '1' && reportStatus == 0 && !forbid"
        >
          <div class="submit df-center" @click="saveIndexOptionList('1')">
            提交
          </div>
        </div>
      </template>

      <template v-else>
        <div></div>
      </template>
    </div>
  </div>
</template>

<script>
import navHeader from "../../components/header/header.vue";
import { mapState } from "vuex";

export default {
  components: {
    navHeader,
  },
  data() {
    return {
      currentTaskId:'',
      reportStatus: 0, // 0 未上报 1 已上报
      reportData: {},
      reportDataList: [],
      reportDataTree: [],
      reportOptionKeyArr: [],
      radio: "1",
      headeName: "",
      // 统计规则的key相关
      showKeyArr: [],
      validKeyArr: [],
      statKeyArr: [],
      forbid: false, // 输入的禁用
    };
  },
  created() {
    this.currentTaskId = localStorage.getItem('taskId')
    this.reportStatus = this.$route.query.reportStatus;
    document.title = this.$route.query.titleName;
    this.headeName = document.title;
  },
  mounted() {
    this.getIndexResultDetailInfo();
  },
  watch: {
    // reportDataList: {
    //   deep: true,
    //   handler: function(newValue,oldValue) {
    //     console.log('newv',newValue);
    //   }
    // }
    // reportDataList(){
    //   console.log(this.reportDataList,'77777');
    // },
    // reportDataTreeCpt(newValue, oldValue) {
    //   if (newValue.length > 0 && oldValue.length > 0) {
    //     this.validData(newValue, oldValue);
    //   }
    //   console.log(newValue, oldValue, "数据...");
    // },
    // deep: true,
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
    reportDataTreeCpt() {
      return this._.cloneDeep(this.reportDataTree);
    },
  },
  methods: {
    // 处理输入
    handleInput(e, item) {
      // 存在最大值
      item.optionValue = item.maxValue
        ? e > item.maxValue
          ? item.maxValue
          : e
        : e;
      if(item.optionValue && item.optionValue.length > 1 && item.optionValue[0] === '0' && `${item.optionValue}`.substring(0,2) != '0.') {        
        item.optionValue = item.optionValue.substring(1,item.length)
      }  
      // 校验
      this.onInputChangeOptsValid(item.optionKey);
      // 统计
      this.onInputChangeOptsStat(item.optionKey);
    },
    // 去修改
    goEdit() {
      if (this.reportStatus == 1) {
        return;
      }
      if (this.$route.query.stepIsEnd == '1') {
        this.$toast('活动已结束，不能进行修改')
        return;
      }
      this.forbid = false;
    },
    // 暂存/提交数据
    saveIndexOptionList(saveState) {
      // saveState = '0'
      // 获取更改的数组
      let optArr = this.getOptionArr();

      console.log(optArr, "rerer");
      // return

      // 先校验必填项
      if (saveState == 1) {
        let requiredPass = this.validIsRequired(optArr);
        console.log(requiredPass, "34343请完善必填项");
        if (!requiredPass) {
          this.$toast("请完善必填项");
          return;
        }
      }

      // 0 暂存  1 提交
      // 再校验数据
      let pass = this.validSubmitData();
      console.log(pass, "通过...");
      // && saveState == 1
      if (!pass) {
        this.$toast("请完善校验数据");
        return;
      }

      // return;

      let p2 = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          id: this.reportData.id,
          indexId: this.reportData.indexId,
          taskLinkId: this.reportData.taskLinkId,
          batch: this.reportData.batch || this.$route.query.batch,
          state: saveState,
          optionList: optArr,
        },
      };

      this.$http.saveIndexOptionList(p2).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$toast(`${saveState == 0 ? "暂存" : "提交"}成功`);
          setTimeout(() => {
            this.$router.go(-1);
            // this.getIndexResultDetailInfo()
            // location.reload();
          }, 500);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    getOptionArr() {
      let arr = [];
      
      let mapArr = this.reportDataList.map((v) => {
        return {
          id: v.id,
          optionName: v.optionName,
          optionKey: v.optionKey,
          optionInputType: v.optionInputType,
          unit: v.unit,
          maxValue: v.maxValue,
          isRequire: v.isRequire,
          optionValue: v.optionValue,
          expression: v.expression,
          expressionVal: v.expressionVal,
          rule: v.rule,
          ruleExplain: v.ruleExplain,
          score: v.score,
          isShow: v.isShow,
        };
      });
      return mapArr;
    },
    // 校验提交的数据
    validSubmitData() {
      let pass = true
      // 吧两层数据再校验一边 提交总验证暂时不做
      this.reportDataList.forEach((v1,v2) => {
         if (v1.errorFlag) {
          pass = false;
        }
      })
      return pass;
    },
    // 校验必填项
    validIsRequired(arr) {
      let pass = true;
      arr.forEach((v, i) => {
        if (
          v.isRequire == "1" &&
          (!v.optionValue || v.optionValue == "") &&
          v.isShow == true
        ) {
          console.log(34343);
          pass = false;
        }
      });
      return pass;
    },
    // 校验数据
    validData(newValue, oldValue, isSubmit = false) {
      let firstLevelIndex = 0;
      let secondLevelIndex = 0;
      // 开始校验
      let firstLevelObj = {};
      let secondLevelObj = {};
      if (!isSubmit) {
        // 先找到被修改数据的坐标
        newValue.forEach((v1, i1) => {
          v1.children.forEach((v2, i2) => {
            let oldOptionValue = oldValue[i1].children[i2].optionValue;
            if (oldOptionValue !== v2.optionValue) {
              firstLevelIndex = i1;
              secondLevelIndex = i2;
            }
          });
        });
        firstLevelObj = newValue[firstLevelIndex];
        secondLevelObj = newValue[firstLevelIndex].children[secondLevelIndex];
      } else {
        firstLevelIndex = newValue;
        secondLevelIndex = oldValue;
        firstLevelObj = this.reportDataTree[firstLevelIndex];
        secondLevelObj =
          this.reportDataTree[firstLevelIndex].children[secondLevelIndex];
      }

      let rule = firstLevelObj.rule;
      let expression = firstLevelObj.expression;

      // 显示隐藏相关
      let secondShowObj =
        this.reportDataTree[firstLevelIndex].children[secondLevelIndex];
      if (
        (secondShowObj.optionInputType === 3 ||
          secondShowObj.optionInputType === 1) &&
        !isSubmit
      ) {
        this.excuteShowRule();
      }

      //  先校验父级相关
      if (rule && rule.length > 0) {
        // let rule = "T2<T4+T5";
        let keyArr = [];
        let tIndex = 0;
        let kFlag = false;
        let newRule = rule;
        newRule = newRule.replace(/\(/g, "");
        newRule = newRule.replace(/\)/g, "");
        let parentKeyArr = newRule
          .trim()
          .split(/\+|\-|\==|\>=|\<=|\>|\<|\/|\*|\&&|\|/);
        let newParentKeyArr = [];
        parentKeyArr.forEach((v, i) => {
          let str = v.trim();
          if (
            str &&
            isNaN(Number(v)) &&
            str.indexOf("%") === -1 &&
            str.indexOf("‰") === -1
          ) {
            newParentKeyArr.push(str);
          }
        });
        keyArr = newParentKeyArr;
        console.log(keyArr, "新校验规则99908080...");
        let keyObjArrValue = [];
        keyArr.forEach((v, i) => {
          console.log(v);
          let obj = this.reportDataList.find((v2) => v2.optionKey === v);
          if (obj) {
            keyObjArrValue.push(obj);
          }
        });
        // 空数据不校验
        let evalFlag = true;
        keyArr.forEach((v, i) => {
          if (
            !keyObjArrValue[i].optionValue &&
            keyObjArrValue[i].optionValue !== "0"
          ) {
            evalFlag = false;
          }
          rule = rule.replace(
            new RegExp(v, "g"),
            keyObjArrValue[i].optionValue ? keyObjArrValue[i].optionValue : 0
          );
        });
        if (evalFlag || isSubmit) {
          console.log(rule, "rule");
          // return
          let validFlag = eval(rule);
          console.log(validFlag);
          if (!validFlag) {
            // 父级报错
            this.$set(this.reportDataTree[firstLevelIndex], "errorFlag", true);
            // this.reportDataTree[firstLevelIndex].errorFlag = true;
            // 子级报错
            this.$set(
              this.reportDataTree[firstLevelIndex].children[secondLevelIndex],
              "iptErrorFlag",
              true
            );
            // this.reportDataTree[firstLevelIndex].children[
            //   secondLevelIndex
            // ].iptErrorFlag = true;
          } else {
            // 父级报错
            // this.reportDataTree[firstLevelIndex].errorFlag = false;
            this.$set(this.reportDataTree[firstLevelIndex], "errorFlag", false);
            // 子级报错
            this.$set(
              this.reportDataTree[firstLevelIndex].children[secondLevelIndex],
              "iptErrorFlag",
              false
            );
            // this.reportDataTree[firstLevelIndex].children[
            //   secondLevelIndex
            // ].iptErrorFlag = false;
          }
          // console.log(this.reportDataTree, "改后的数据...");
        }
      }
      // 再校验子集
      let chilrenRule = secondLevelObj.rule;
      console.log(chilrenRule, "原始chilrenRule");
      let chilrenExpression = secondLevelObj.expression;
      console.log(chilrenRule, "232");
      if (chilrenRule && chilrenRule.length > 0) {
        let newChilrenRule = chilrenRule;
        newChilrenRule = newChilrenRule.replace(/\(/g, "");
        newChilrenRule = newChilrenRule.replace(/\)/g, "");
        let chilrenKeyArr = newChilrenRule
          .trim()
          .split(/\+|\-|\==|\>=|\<=|\>|\<|\/|\*|\&&|\|/);
        let newChildrenKeyArr = [];
        chilrenKeyArr.forEach((v, i) => {
          let str = v.trim();
          if (
            str &&
            isNaN(Number(v)) &&
            str.indexOf("%") === -1 &&
            str.indexOf("‰") === -1
          ) {
            newChildrenKeyArr.push(str);
          }
        });
        console.log(newChildrenKeyArr, "新校验规则99...");
        // return
        // let rule = "T2<T4+T5";
        let keyArr = [];
        keyArr = newChildrenKeyArr;
        let keyObjArrValue = [];
        console.log(this.reportDataList, "67676");
        keyArr.forEach((v, i) => {
          console.log(v);
          let obj = this.reportDataList.find((v2) => v2.optionKey === v);
          if (obj) {
            keyObjArrValue.push(obj);
          }
        });
        console.log(keyArr, "值key....");
        console.log(keyObjArrValue, "值value....");
        let evalFalgs = true;
        keyArr.forEach((v, i) => {
          if (
            !keyObjArrValue[i].optionValue &&
            keyObjArrValue[i].optionValue !== "0"
          ) {
            evalFalgs = false;
          }
          chilrenRule = chilrenRule.replace(
            new RegExp(v, "g"),
            keyObjArrValue[i].optionValue ? keyObjArrValue[i].optionValue : 0
          );
        });
        if (evalFalgs || isSubmit) {
          console.log(chilrenRule, "改后chilrenRule");
          let validFlag = eval(chilrenRule);
          console.log(validFlag);
          if (!validFlag) {
            // 子级报错
            // this.reportDataTree[firstLevelIndex].children[
            //   secondLevelIndex
            // ].errorFlag = true;
            this.$set(
              this.reportDataTree[firstLevelIndex].children[secondLevelIndex],
              "errorFlag",
              true
            );
          } else {
            // 子级报错
            // this.reportDataTree[firstLevelIndex].children[
            //   secondLevelIndex
            // ].errorFlag = false;
            this.$set(
              this.reportDataTree[firstLevelIndex].children[secondLevelIndex],
              "errorFlag",
              false
            );
            // this.reportDataTree[firstLevelIndex].children.forEach((v) => {
            //   v.errorFlag = false;
            // });
          }
          console.log(this.reportDataTree, "改后的数据...");
        }
      }

      // 最后再统计
      if (
        !isSubmit &&
        expression &&
        expression.length > 0 &&
        !this.reportDataTree[firstLevelIndex].errorFlag &&
        !this.reportDataTree[firstLevelIndex].children[secondLevelIndex]
          .iptErrorFlag &&
        !this.reportDataTree[firstLevelIndex].children[secondLevelIndex]
          .errorFlag
      ) {
        //  T2/(T4+T5)##%
        let keyArr = [];
        let tIndex = 0;
        let kFlag = false;
        let newKeyArr = [];
        let expressKeyArr1 = expression.split("##")[0];
        expressKeyArr1 = expressKeyArr1.replace(/\(/g, "");
        expressKeyArr1 = expressKeyArr1.replace(/\)/g, "");
        let expressKeySplitArr = expressKeyArr1
          .trim()
          .split(/\+|\-|\==|\>=|\<=|\>|\<|\/|\*|\&&|\|/);
        expressKeySplitArr.forEach((v, i) => {
          let str = v.trim();
          if (
            str &&
            isNaN(Number(v)) &&
            str.indexOf("%") === -1 &&
            str.indexOf("‰") === -1
          ) {
            newKeyArr.push(str);
          }
        });
        keyArr = newKeyArr;
        let keyObjArrValue = [];
        keyArr.forEach((v, i) => {
          console.log(v);
          let obj = this.reportDataList.find((v2) => v2.optionKey === v);
          if (obj) {
            keyObjArrValue.push(obj);
          }
        });
        console.log(expression, "expression6788");
        let evalFlag = true;
        console.log(keyArr, keyObjArrValue, "23232");
        keyArr.forEach((v, i) => {
          console.log(keyObjArrValue[i], "343");
          if (keyObjArrValue[i]) {
            expression = expression.replace(
              new RegExp(v, "g"),
              keyObjArrValue[i].optionValue ? keyObjArrValue[i].optionValue : 0
            );
          } else {
            evalFlag = false;
          }
        });
        if (!evalFlag) return;
        console.log(expression, "expression");
        if (expression.search("##") != -1) {
          let expressionArr = expression.split("##");
          let expressionV = eval(expressionArr[0]);
          expressionV =
            isNaN(Number(expressionV)) || !isFinite(expressionV)
              ? 0
              : expressionV;
          if (expressionArr[1] == "%") {
            expressionV = (expressionV * 100).toFixed(2) + "%";
          } else if (expressionArr[1] == "‰") {
            expressionV = (expressionV * 1000).toFixed(2) + "‰";
          } else {
            expressionV = expressionV.toFixed(2) + expressionArr[1];
          }
          this.reportDataTree[firstLevelIndex].expressionVal = expressionV;
          console.log(expressionV, "afterexpressionV");
        }
      }
    },
    // 字符串名变变量名
    stringToName(string) {
      let _name = "var new_name=" + string;
      eval(_name);
      return _name;
    },
    // 获取报告列表数据
    getIndexResultDetailInfo() {
      let params = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          taskId: this.currentTaskId,
          comId: this._userInfo.data.comId,
          indexId: this.$route.query.indexId,
          taskLinkId: this.$route.query.taskLinkId,
          isPreface: "0",
        },
      };
      this.$http.getIndexResultDetailInfo(params).then((res) => {
        if (res.code === 0) {
          this.reportData = res.data ? res.data : [];
          // let newDataArr = this._.cloneDeep(res.data.optionList);
          this.reportDataList = res.data.optionList;
          // let filterKeyArr = newDataArr.filter((v) => v.optionInputType != 7);
          // let filterKeyArr = newDataArr.filter((v) => v.optionInputType != 7);
          // // console.log(filterKeyArr, "6688899");
          // this.reportOptionKeyArr = newDataArr.map((v) => v.optionKey);
          // console.log(this.reportOptionKeyArr, "keykey...");
          this.forbid =
            this.reportData.state === "1" || this.reportData.state === "2";
          // 初始化配置
          this.initOptionsSetting();
          console.log(this.forbid, "禁用...");
          console.log(this.reportDataList, "所有的列表数据..");
          console.log(this.showKeyArr, "所有的显示key..");
          console.log(this.validKeyArr, "所有的校验key..");
          console.log(this.statKeyArr, "所有的统计key..");
          // this.generatorReportTree(this.reportDataList);
          if (this.reportDataList.length == 0) {
            this.$toast("暂无数据");
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 构建报告列表树
    generatorReportTree(reportList) {
      reportList.forEach((v, i) => {
        v.localValue = "";
        // 1. 初始化自身显示隐藏
        if (v.showRule && v.showRule.length > 0) {
          let isShow = this.excuteRule(v.showRule, reportList);
          v.isShow = isShow;
        } else {
          v.isShow = true;
        }

        v.errorFlag = false;
        // 如果是7就跳过不显示
        // if (v.optionInputType != 7) {
        // 2. 标题 构建报告树
        if (v.optionInputType == 6) {
          v.children = [];
          this.reportDataTree.push(v);
          v.childMsg = "";
        } else {
          v.iptErrorFlag = false;
          this.reportDataTree[this.reportDataTree.length - 1].children.push(v);
        }
        // }
      });

      //
      console.log(this.reportDataTree);
    },
    // 初始化配置
    initOptionsSetting() {
      this.reportDataList.forEach((v, i) => {
        // 1. 判断标题下最后一个选项
        if (v.optionInputType == 6 && i - 1 > 0) {
          this.reportDataList[i - 1].lastOptions = true;
        } else {
          v.lastOptions = false;
        }

        // 2. 初始化自身显示隐藏, 把显示隐藏的key存到二维数组中
        if (v.showRule && v.showRule.length > 0) {
          let arr = this.findKeyArr(v.showRule);
          this.showKeyArr[i] = arr;
          let isShow = this.excuteRule(v.showRule, this.reportDataList);
          v.isShow = isShow;
        } else {
          this.showKeyArr[i] = [];
          v.isShow = true;
        }

        // 3. 初始化校验keyArr
        if (v.rule && v.rule.length > 0) {
          let arr = this.findKeyArr(v.rule);
          this.validKeyArr[i] = arr;
        } else {
          this.validKeyArr[i] = [];
        }

        // 4. 初始化统计keyArr
        if (v.expression && v.expression.length > 0) {
          let arr = this.findKeyArr(v.expression, true);
          this.statKeyArr[i] = arr;
        } else {
          this.statKeyArr[i] = [];
        }
      });
      // 最后一项需加 lastOptions
      this.reportDataList[this.reportDataList.length -1].lastOptions = true
    },
    // 找key的方法 规则, 是否统计规则
    findKeyArr(rule, isState = false) {
      let newRule = rule;
      if (isState) {
        newRule = rule.split("##")[0];
      }
      newRule = newRule.replace(/\(/g, "");
      newRule = newRule.replace(/\)/g, "");
      // 找key
      let keyArr = newRule.trim().split(/\+|\-|\==|\>=|\<=|\>|\<|\/|\*|\&&|\|/);
      let newKeyArr = [];
      keyArr.forEach((v, i) => {
        let str = v.trim();
        if (
          str &&
          isNaN(Number(v)) &&
          str.indexOf("%") === -1 &&
          str.indexOf("‰") === -1
        ) {
          newKeyArr.push(str);
        }
      });
      return newKeyArr;
    },
    // 执行规则返回结果
    excuteRule(rule, reportList, keyArr = false, isValid = false) {
      let newKeyArr = keyArr ? keyArr : this.findKeyArr(rule);
      console.log(newKeyArr, "新校验规则key..");
      // 找value
      let keyObjArrValue = [];
      newKeyArr.forEach((v, i) => {
        console.log(v);
        let obj = reportList.find((v2) => v2.optionKey === v);
        if (obj) {
          keyObjArrValue.push(obj);
        }
      });
      // console.log(keyObjArrValue, "值value....");
      let evalFlag = true;
      // 替换规则
      newKeyArr.forEach((v, i) => {
        if (
          !keyObjArrValue[i].optionValue &&
          keyObjArrValue[i].optionValue !== 0 &&
          keyObjArrValue[i].optionValue !== "0"
        ) {
          evalFlag = false;
        }
        rule = rule.replace(
          new RegExp(v, "g"),
          keyObjArrValue[i].optionValue ? keyObjArrValue[i].optionValue : 0
        );
      });
      // 是走校验但是校验为空时, 默认不校验
      if (!evalFlag && isValid) {
        return "noPass";
      }
      console.log(rule, "替换规则后的rule");
      // 执行规则
      let res = eval(rule);
      console.log(res, "执行结果");
      return res;
    },
    // 控制显示隐藏,
    excuteShowRule() {
      this.reportDataTree.forEach((v1, i1) => {
        if (v1.showRule && v1.showRule.length > 0) {
          let isShow = this.excuteRule(v1.showRule, this.reportDataList);
          v1.isShow = isShow;
        }
        v1.children.forEach((v2, i2) => {
          if (v2.showRule && v2.showRule.length > 0) {
            let isShow = this.excuteRule(v2.showRule, this.reportDataList);
            v2.isShow = isShow;
          }
        });
      });
    },
    // 切换选项
    toggleRadioChange(item, index) {
      this.onRadioChangeOptsShow(item.optionKey);
    },
    // 切换按钮下面的显示隐藏
    onRadioChangeOptsShow(key) {
      this.showKeyArr.forEach((v0, i0) => {
        let index = v0.indexOf(key);
        if (index > -1) {
          let res = this.excuteRule(
            this.reportDataList[i0].showRule,
            this.reportDataList,
            v0
          );
          this.reportDataList[i0].isShow = res ? true : false;
          this.$set(this.reportDataList, i0, this.reportDataList[i0]);
        }
      });
    },
    // 输入时校验
    onInputChangeOptsValid(key) {
      this.validKeyArr.forEach((v0, i0) => {
        let index = v0.indexOf(key);
        if (index > -1) {
          let res = this.excuteRule(
            this.reportDataList[i0].rule,
            this.reportDataList,
            v0,
            true
          );
          if (res !== "noPass") {
            this.reportDataList[i0].errorFlag = res ? false : true;
            this.$set(this.reportDataList, i0, this.reportDataList[i0]);
          }
        }
      });
    },
    // 输入时统计
    onInputChangeOptsStat(key) {
      this.statKeyArr.forEach((v0, i0) => {
        let index = v0.indexOf(key);     
        if (index > -1) {
          let expressionPost = this.reportDataList[i0].expression.split("##")[1]
          let res = this.excuteRule(
            this.reportDataList[i0].expression.split("##")[0],
            this.reportDataList,
            v0,
            true
          );
          if (res !== "noPass") {
            res = isNaN(Number(res)) || !isFinite(res) ? 0 : res;
            if (expressionPost == "%") {
              res = (res * 100).toFixed(2) + "%";
            } else if (expressionPost == "‰") {
              res = (res * 1000).toFixed(2) + "‰";
            } else {
              res = res.toFixed(2) + expressionPost;
            }
            this.reportDataList[i0].expressionVal = res;
            this.$set(this.reportDataList, i0, this.reportDataList[i0]);
          }
        }
      });
    },
    // 处理统计的数据 数字 规则
    hanldeStatData(res, rule) {},
  },
};
</script>

<style lang='scss' scoped>
.qualityIndicatorsReport {
  background-color: #f2f2f2;
  height: 100vh;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  display: flex;
  flex-direction: column;
  .asterisk {
    color: red;
    font-size: 16px;
    margin-right: 3px;
    // margin-top: 3px;
  }
  .container {
    flex: 1;
    overflow: scroll;
  }
  .user-info {
    min-height: 82px;
    background: #e5efff;
    box-sizing: border-box;
    padding: 10px 15px 15px;
    margin-bottom: 10px;
    .status {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    .edit-btn {
      width: 90px;
      height: 30px;
      opacity: 1;
      border: 1px solid #26b4ff;
      border-radius: 17px;
      font-size: 15px;
      color: #26b4ff;
    }
    .row-update-info {
      margin-top: 6px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      span {
        margin-right: 8px;
      }
    }
  }
  .card-container {
    .card {
      box-sizing: border-box;
      // padding: 15px 14px 20px 15px;
      padding: 0 14px 0 15px;
      background-color: #fff !important;
      // margin-bottom: 10px;
      .title-box {
        padding-top: 15px;
        .main-title {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
          }
          .rate {
            flex-shrink: 0;
            font-size: 14px;
            color: rgb(51, 153, 255);
          }
        }
        .sub-title {
          // margin-top: 5px;
          padding-top: 5px;
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 20px;
        }
      }
      .cell-item {
        width: 100%;
        align-items: center;
        padding-top: 15px;
        // margin-top: 15px;
        min-height: 40px;
        padding-bottom: 10px;
        // margin-bottom: 10px;
        .title {
          text-align: left;
          // width: 180px;
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        input,
        .va-input {
          margin: 0 5px;
          display: flex;
          align-items: center;
          width: 115px;
          height: 38px;
          background: #ffffff;
          border: 1px solid #cccccc;
          font-size: 16px;
          padding: 0;
          // text-align: center;
          // line-height: 22px;
        }
        ::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: #999999;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999999;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999999;
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999999;
        }
        .unit {
          // flex-shrink: 0;
          text-align: right;
          width: 50px;
          // flex-shrink: 0;
          margin-left: auto;
          font-size: 16px;
          color: #333333;
        }
      }
      .card-hodler {
        height: 20px;
        width: 100%;
      }
    }
    .last-option {
      padding-bottom: 20px;
      margin-bottom: 10px;
    }
  }
  .btn-group {
    position: fixed;
    width: 100%;
    height: 44px;
    background: #ffffff;
    z-index: 99;
    bottom: 0;
    box-sizing: border-box;
    div {
      flex: 1;
      height: 100%;
    }
    .storage {
      background: #ffffff;
      font-size: 18px;
      color: #1c91ff;
    }
    .submit {
      background: #1c91ff;
      font-size: 18px;
      color: #ffffff;
    }
  }
  .error-ipt {
    border: 1px solid #ff4444 !important;
    color: #ff4444 !important;
    /deep/ .van-field__control {
      color: #ff4444;
    }
  }
  .error-tip {
    align-items: center;
    margin-top: 10;
    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
    span {
      font-size: 14px;
      color: #ff4158;
    }
  }

  /deep/ .van-radio__label {
    margin-right: 60px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
    color: #333;
    line-height: 20px;
  }
  .holder-box {
    width: 100%;
    height: 60px;
  }
}
</style>